<template>
  <!-- The brand-data ad's artwork: an abridged API response, with a swatch
       beside every hex — the part of the payload Colorize visitors came for.
       Decorative: the ad's copy already says what the API returns, and a
       screen reader reading JSON punctuation aloud helps nobody. -->
  <CodeWindow :html="html" :lines="10" aria-hidden="true">
    <template #header>
      <span class="rounded bg-emerald-500/15 px-1.5 py-0.5 font-mono text-2xs font-semibold text-emerald-300">GET</span>
      <span class="min-w-0 flex-1 truncate font-mono text-xs text-gray-400">/brand?url=<span class="text-gray-200">stripe.com</span></span>
    </template>
  </CodeWindow>
</template>

<script setup>
import CodeWindow from '~/components/atoms/CodeWindow.vue'
import { highlightCode } from '~/utils/highlightCode'

// The same example prefetch.io uses in its own quickstart, so the two sites
// show one response rather than two.
const response = `{
  "name": "Stripe",
  "colors": [
    "#635BFF",
    "#0A2540",
    "#00D4FF"
  ],
  "fonts": ["Sohne", "Inter"],
  "logo": "…/stripe.svg"
}`

// A swatch in front of each hex string. The hexes are the constants above, not
// input, so they're safe to put in a style attribute.
const html = highlightCode(response, 'json').replace(
  /<span class="tok-string">"(#[0-9A-F]{6})"<\/span>/g,
  (string, hex) =>
    `<span class="inline-block h-2.5 w-2.5 rounded-sm align-[-1px] ring-1 ring-inset ring-white/20" style="background:${hex}"></span> ${string}`,
)
</script>
